import {useCallback, useState} from 'react';

export const useContactField = <T>(defaultValue: T, validator?: (value: T, isFilled: boolean) => string | boolean) => {
    const [value, setValue] = useState<T>(defaultValue);
    const [hash, setHash] = useState<string | null>(null);
    const [isFilled, setIsFilled] = useState(false);
    const [isFocused, setIsFocused] = useState(false);
    const [error, setError] = useState<string | boolean>(false);

    const validate = useCallback(
        (newValue?: T) => {
            let error: string | boolean = false;
            if (validator) {
                error = validator(newValue !== undefined ? newValue : value, isFilled);
            }
            setError(error);
            return error;
        },
        [validator, value, isFilled],
    );

    const onChange = useCallback(
        (value: T, hash?: string) => {
            setValue(value);
            setIsFilled(!!hash);
            if (error) {
                validate(value);
            }
            if (hash) {
                setHash(hash);
            }
        },
        [error, validate],
    );

    const onСancelFilling = useCallback(() => {
        setValue(defaultValue);
        setIsFilled(false);
    }, [defaultValue]);

    const onFocus = useCallback(() => {
        setIsFocused(true);
    }, []);

    const onBlur = useCallback(() => {
        setIsFocused(false);
        validate();
    }, [validate]);

    return {
        value,
        hash,
        isFilled,
        isFocused,
        hasError: !!error,
        error,
        validate,
        setHash,
        setError,
        onChange,
        onСancelFilling,
        onFocus,
        onBlur,
    };
};
